import styled from 'src/styles/theme';
import { ModalPostalCodeStyled } from '../ModalPostalCodeStyled';
import { rem } from 'polished';

export const ModalPostalCodeStyledDS = styled(ModalPostalCodeStyled)`
    .title {
        font-size: ${({ theme }) => theme.fontSizes.h3};
    }

    .description {
        font-size: ${({ theme }) => theme.fontSizes.h6};
    }

    .input {
        button {
            font-weight: ${({ theme }) => theme.fontWeights.textRegular};
            font-size: ${({ theme }) => theme.fontSizes.h5};
            border-radius: ${rem(24)};
            padding: ${rem(15)} ${rem(24)};
            background: ${({ theme }) => theme.colors.black};

            &:hover,
            &:focus-visible {
                background: ${({ theme }) => theme.colors.primary};
            }
        }
    }
`;
